import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dc101a9e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "pending-topup-list" }
const _hoisted_2 = { class: "top-up-info" }
const _hoisted_3 = { class: "top-up-info" }
const _hoisted_4 = { class: "top-up-info" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TransactionItem = _resolveComponent("TransactionItem")!
  const _component_FoldableSectionCard = _resolveComponent("FoldableSectionCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.pendingMyUnpaidTopUpList.length)
      ? (_openBlock(), _createBlock(_component_FoldableSectionCard, {
          key: 0,
          id: "pending-top-up-list",
          title: _ctx.$gettext('My unpaid top-up requests'),
          count: _ctx.pendingMyUnpaidTopUpList.length
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$gettext("The following top up requests needs to be paid or canceled")), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pendingMyUnpaidTopUpList, (topup) => {
              return (_openBlock(), _createBlock(_component_TransactionItem, {
                key: topup,
                class: "pending-top-up-item",
                transaction: topup,
                account: _ctx.account,
                onRefreshTransaction: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('refreshTransaction')))
              }, null, 8, ["transaction", "account"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["title", "count"]))
      : _createCommentVNode("", true),
    (
        _ctx.$config.disableDisplayOtherUnpaidTopup !== true &&
        _ctx.pendingOthersUnpaidTopUpList.length
      )
      ? (_openBlock(), _createBlock(_component_FoldableSectionCard, {
          key: 1,
          id: "pending-top-up-list",
          title: _ctx.$gettext('Pending top-up requests'),
          count: _ctx.pendingOthersUnpaidTopUpList.length
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$gettext("The following top up requests await payment by third party")), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pendingOthersUnpaidTopUpList, (topup) => {
              return (_openBlock(), _createBlock(_component_TransactionItem, {
                key: topup,
                class: "pending-top-up-item",
                transaction: topup,
                account: _ctx.account,
                onRefreshTransaction: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('refreshTransaction')))
              }, null, 8, ["transaction", "account"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["title", "count"]))
      : _createCommentVNode("", true),
    (_ctx.pendingPaidTopUpList.length)
      ? (_openBlock(), _createBlock(_component_FoldableSectionCard, {
          key: 2,
          title: _ctx.$gettext('Top up waiting admin validation'),
          count: _ctx.pendingPaidTopUpList.length
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$gettext(
            "The following top up have been paid and are waiting for an administrator of your local currency to validate them."
          )), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pendingPaidTopUpList, (topup) => {
              return (_openBlock(), _createBlock(_component_TransactionItem, {
                key: topup,
                transaction: topup,
                account: _ctx.account,
                onRefreshTransaction: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('refreshTransaction')))
              }, null, 8, ["transaction", "account"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["title", "count"]))
      : _createCommentVNode("", true)
  ]))
}